"use client";

import { z } from "zod";

import type { UseRequestMutationProps } from "../../../request/hooks/useRequestMutation";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";

export type UseRequestMagicLinkProps = UseRequestMutationProps;

export const useRequestMagicLink = ({
  ...props
}: UseRequestMagicLinkProps = {}) => ({
  ...props,
  mutationPost: useRequestMutation({
    mutationFnRequestProps: (data: {
      email: string;
      redirect_path: string;
    }) => ({
      body: JSON.stringify(data),
      method: "POST",
      requestType: "default",
      schema: z.boolean(),
      urlBackendPath: "/magic-link",
    }),
    onMutate: () => ({ noRefresh: true }),
  }),
});
